import DeckCommonCardsFilter from "@/lib/games/onePiece/DeckCommonCardsFilter";
import NameFilter from "@/components/Filters/NameFilter";
import SearchSelect from "@/components/Filters/SearchSelect";
import ColorFilter from "@/components/Filters/ColorFilter";
import CostFilter from "@/components/Filters/CostFilter";
import PowerFilter from "@/components/Filters/PowerFilter";
import TypeFilter from "@/components/Filters/TypeFilter";
import CounterFilter from "@/components/Filters/CounterFilter";
import AttributeFilter from "@/components/Filters/AttributeFilter";
import ShowAAsFilter from "@/components/Filters/ShowAAsFilter";
import { Button } from "@heroui/react";

interface DeckCardsMap {
  [key: string]: {
    count: number;
    cards: string[];
  };
}

interface Filters {
  searchSelect: Set<string>;
  deckCommonCards: Set<string>;
  color: Set<string>;
  cost: Set<string>;
  power: Set<string>;
  type: Set<string>;
  counter: Set<string>;
  attribute: Set<string>;
  showAAs: boolean;
}

interface OPFiltersProps {
  filters: Filters;
  setFilter: (key: keyof Filters, value: any) => void;
  searchDisplay: string;
  setSearchDisplay: (value: string) => void;
  deckCardsMap: DeckCardsMap;
  clearAllFilters: () => void;
}

export default function OPFilters({
  filters,
  setFilter,
  searchDisplay,
  setSearchDisplay,
  deckCardsMap,
  clearAllFilters,
}: OPFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 mt-2 mb-2 items-center">
      <div className="flex flex-row">
        <SearchSelect
          selected={filters.searchSelect}
          setSelected={(val: any) => setFilter("searchSelect", val)}
        />
        <NameFilter
          selected={searchDisplay}
          setSelected={setSearchDisplay}
          placeholder={"Search"}
          rounded="rounded-l-none"
        />
      </div>
      <DeckCommonCardsFilter
        selected={filters.deckCommonCards}
        setSelected={(val: any) => setFilter("deckCommonCards", val)}
        deckCardsMap={deckCardsMap}
      />
      <ColorFilter
        selected={filters.color}
        setSelected={(val: any) => setFilter("color", val)}
      />
      <CostFilter
        selected={filters.cost}
        setSelected={(val: any) => setFilter("cost", val)}
      />
      <PowerFilter
        selected={filters.power}
        setSelected={(val: any) => setFilter("power", val)}
      />
      <TypeFilter
        selected={filters.type}
        setSelected={(val: any) => setFilter("type", val)}
      />
      <CounterFilter
        selected={filters.counter}
        setSelected={(val: any) => setFilter("counter", val)}
      />
      <AttributeFilter
        selected={filters.attribute}
        setSelected={(val: any) => setFilter("attribute", val)}
      />
      <ShowAAsFilter
        selected={filters.showAAs}
        setSelected={(val: any) => setFilter("showAAs", val)}
      />
      <Button
        // color="primary"
        // variant=""
        onPress={() => {
          clearAllFilters();
        }}
        radius="sm"
        className="h-[30px]"
        // endContent={<IconX height={14} width={14} />}
      >
        Clear
      </Button>
    </div>
  );
}
